var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-obras"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"listadoLicitaciones":_vm.listadoLicitaciones}})]:[_c('mobile',{attrs:{"listadoLicitaciones":_vm.listadoLicitaciones}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }